import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 20,
      right: 20,
      background: 'var(--color-bg-card)',
      borderRadius: 12,
      padding: 16,
      boxShadow: '0 4px 24px var(--color-shadow)',
      border: '1px solid var(--color-border)',
      minWidth: 200,
      zIndex: 1000,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: '50%',
          background: 'var(--color-primary)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontSize: 16, fontWeight: 'bold', flexShrink: 0,
        }}>
          {(user.displayName || user.email).charAt(0).toUpperCase()}
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ color: 'var(--color-text)', fontWeight: 'bold', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user.displayName || 'User'}
          </div>
          <div style={{ color: 'var(--color-secondary)', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user.email}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
